import { CSSProperties } from 'react';

export const messageStyle: CSSProperties = {
  textAlign: 'left',
};
